import * as React from 'react';

import { Props } from './component';

export interface UseAnnouncementOutput {
  hasOverflow: boolean;
  handleReadMoreClick: () => void;
}

export const useAnnouncement = (
  ref: React.RefObject<HTMLDivElement>,
  props: Props,
): UseAnnouncementOutput => {
  const {
    onReadMoreClick,
    announcement: { id },
  } = props;
  const [hasOverflow, setHasOverflow] = React.useState(false);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }
    const newOverflowState =
      ref.current.offsetHeight < ref.current.scrollHeight;
    if (hasOverflow !== newOverflowState) {
      setHasOverflow(newOverflowState);
    }
  }, [ref, hasOverflow, setHasOverflow]);

  const handleReadMoreClick = React.useCallback(() => {
    if (onReadMoreClick) {
      onReadMoreClick(id);
    }
  }, [onReadMoreClick, id]);

  return { hasOverflow, handleReadMoreClick };
};
